import React from 'react';
import Button from './Button';

const CTWaitScreen = ({ onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl p-8 max-w-md mx-4 text-center">
                <div className="mb-6">
                    <svg className="w-32 h-32 mx-auto" viewBox="0 0 200 200" fill="none">
                        {/* Cute sleeping moon character */}
                        <circle cx="100" cy="100" r="60" fill="#FFE4B5" stroke="#FFD700" strokeWidth="3" />

                        {/* Sleeping face */}
                        <path d="M80 90 Q85 85 90 90" stroke="#FF6B6B" strokeWidth="3" fill="none" strokeLinecap="round" />
                        <path d="M110 90 Q115 85 120 90" stroke="#FF6B6B" strokeWidth="3" fill="none" strokeLinecap="round" />

                        {/* Peaceful smile */}
                        <path d="M85 115 Q100 125 115 115" stroke="#FF6B6B" strokeWidth="3" fill="none" strokeLinecap="round" />

                        {/* Rosy cheeks */}
                        <circle cx="70" cy="105" r="8" fill="#FFB6C1" opacity="0.6" />
                        <circle cx="130" cy="105" r="8" fill="#FFB6C1" opacity="0.6" />

                        {/* Sleep cap */}
                        <path d="M70 60 Q100 40 130 60 Q125 50 100 45 Q75 50 70 60" fill="#4A90E2" />
                        <circle cx="135" cy="45" r="8" fill="#FFD700" />

                        {/* Zzz sleep symbols */}
                        <text x="140" y="75" fill="#4A90E2" fontSize="16" fontFamily="Arial" fontWeight="bold">Z</text>
                        <text x="150" y="65" fill="#4A90E2" fontSize="12" fontFamily="Arial" fontWeight="bold">z</text>
                        <text x="158" y="58" fill="#4A90E2" fontSize="8" fontFamily="Arial" fontWeight="bold">z</text>

                        {/* Stars around */}
                        <polygon points="45,45 47,50 52,50 48,53 50,58 45,55 40,58 42,53 38,50 43,50" fill="#FFD700" />
                        <polygon points="160,85 162,90 167,90 163,93 165,98 160,95 155,98 157,93 153,90 158,90" fill="#FFD700" />
                        <polygon points="35,120 37,125 42,125 38,128 40,133 35,130 30,133 32,128 28,125 33,125" fill="#FFD700" />
                    </svg>
                </div>

                <div className="bg-gray-100 rounded-2xl p-6 mb-6">
                    <h2 className="text-2xl font-bold text-gray-800 leading-tight">
                        SEE YOU TOMORROW FOR YOUR NEXT LESSON.
                    </h2>
                </div>

                <Button
                    onClick={onClose}
                    background="blue"
                    title="OK"
                    className="w-full"
                />
            </div>
        </div>
    );
};

export default CTWaitScreen;